<template>
  <div class="reference-iiko layout">
    <access-sidesheet
      ref="accessModal"
      @updated="updateAccessData"
      @created="addAccessData"
      @remove="updateList()"
    ></access-sidesheet>

    <remove-access-modal ref="removeAccessModal" @remove="updateList()"></remove-access-modal>

    <div class="layout-header">
      <div class="layout-title">Настройки доступов к IIKO</div>
      <div class="layout-header-actions">
        <div class="layout-header-action">
          <c-button2
            size="small"
            :icon="{
              icon: 'bookmark',
              activeColor: 'white',
            }"
            :tooltip="{
              text: 'Добавить в закладки',
              activeText: 'Убрать из закладок',
            }"
            active-color="blue"
            :active="bookmark"
            @click="bookmark = !bookmark"
          />
        </div>
        <div class="layout-header-action">
          <c-button2
            :responsive="true"
            size="small"
            label="Новый доступ"
            :icon="{ icon: 'plus', color: 'primary' }"
            @click="addAccess"
          />
        </div>
      </div>
    </div>

    <div class="reference-iiko__content">
      <div class="reference-iiko__search">
        <c-input
          v-model="query"
          placeholder="Поиск по названию/ID терминала, хосту, логину"
          :clearable="true"
          icon="search"
          @enter="updateList"
        />
      </div>

      <template v-if="inited">
        <accesses-table
          :loading="loading"
          :list="list"
          :sort-by="sortBy"
          :page="page"
          @sort="sort"
          @nextPage="nextPage"
          @remove="removeAccess"
          @edit="editAccess"
        ></accesses-table>
      </template>

      <c-loader v-if="!inited" :active="!inited" label="Данные загружаются" :height="300"></c-loader>
    </div>

    <top-button root=".layout"></top-button>
  </div>
</template>

<script>
import CButton2 from "@/components/controls2/Button";
import CInput from "@/components/controls2/Input";
import TopButton from "@/components/top-button";
import CLoader from "@/components/loader";

import AccessSidesheet from "./components/access-sidesheet";
import AccessesTable from "./components/accesses-table";
import RemoveAccessModal from "./components/remove-access-modal";

export default {
  components: {
    CButton2,
    CInput,
    CLoader,
    TopButton,
    AccessSidesheet,
    AccessesTable,
    RemoveAccessModal,
  },

  data() {
    return {
      bookmark: false,

      query: "",
      sortBy: "",
      desc: false,
      page: 1,

      inited: false,
      loading: false,
      isLastRequestEmpty: false,

      list: [],

      outOfTurn: null,
    };
  },

  computed: {
    formattedQuery() {
      return this.query.trim().toLowerCase();
    },
  },

  created() {
    const sp = this.$route.query;
    this.query = sp.query || "";
    if (sp.sortBy) {
      this.sortBy = sp.sortBy;
      this.desc = sp.desc.toString() === "1";
    }

    this.loadList();
  },

  methods: {
    removeAccess(access) {
      this.$refs.removeAccessModal.open(access);
    },
    editAccess(access) {
      this.$refs.accessModal.open(access);
    },
    addAccess() {
      this.$refs.accessModal.open();
    },
    getParams() {
      return {
        query: this.formattedQuery,
        sortBy: this.sortBy,
        desc: this.desc,
        page: this.page,
      };
    },
    saveParams(params) {
      const sp = {
        ...this.$route.query,
        query: params.query,
        sortBy: params.sortBy,
        desc: params.desc ? 1 : 0,
      };
      this.$router
        .push({
          name: "reference-iiko",
          query: sp,
        })
        .catch(() => {});
    },
    loadList() {
      this.loading = true;
      const delay = new Promise((res) => {
        setTimeout(() => res(), 1000);
      });

      const params = this.getParams();
      this.saveParams(params);

      this.$store.dispatch("referenceIiko/loadList", params).then((items) => {
        if (!items.length < 30) this.isLastRequestEmpty = true;
        if (this.outOfTurn) {
          // undefined variable "item"
          // item = items.filter((item) => item.id !== this.outOfTurn);
        }
        this.list = [...this.list, ...items];

        delay.then(() => {
          this.loading = false;
          this.inited = true;
        });
      });
    },
    updateList() {
      this.list = [];
      this.page = 1;
      this.inited = false;
      this.loading = false;
      this.isLastRequestEmpty = false;
      this.outOfTurn = null;
      this.loadList();
    },
    nextPage() {
      if (!this.inited) return;
      if (this.loading) return;
      if (this.isLastRequestEmpty) return;
      this.page += 1;
      this.loadList();
    },
    sort(sortBy) {
      if (this.sortBy === sortBy) {
        this.desc = !this.desc;
      } else {
        this.sortBy = sortBy;
        this.desc = false;
      }
      this.updateList();
    },

    updateAccessData(access) {
      this.list = this.list.map((item) => {
        if (item.id === access.id) return access;
        return item;
      });
    },
    addAccessData(access) {
      this.list = [access, ...this.list];
      this.outOfTurn = access.id;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/vars";
.reference-iiko {
  &__search {
    margin-bottom: 33px;
    max-width: 564px;

    & /deep/ {
      input::placeholder {
        font-style: italic;
      }
    }

    @include mobileAndTablet {
      max-width: none;
      width: 100%;
    }
  }

  @include onlyMobile {
    .layout-header {
      height: auto;
    }
    .layout-title {
      padding-top: 5px;
    }
  }
}
</style>
